var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"further-skills-display"},[_c('ul',_vm._l((_vm.values),function(val,idx){return _c('li',{key:idx},[_c('i',{staticClass:"fontello icon-check"}),_vm._v(" "+_vm._s(val.skillName)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }